import "@arco-design/web-react/es/Drawer/style/css";
import _Drawer from "@arco-design/web-react/es/Drawer";
/* __next_internal_client_entry_do_not_use__ default auto */import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useEffect } from "react";
import { usePopups } from "@/store/popups";
import "./index.module.scss";
import { OtherPopupRecord } from "./other";
const PopupComp = /*#__PURE__*/memo(() => {
  const [stacks, popupDispatch] = usePopups(state => [state.showStacks, state.dispatch]);
  //esc关闭
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.code === "Escape") {
        if (stacks.length > 0) {
          if (OtherPopupRecord["arco_trigger"]) {
            return;
          }
          const visibledStacks = stacks.filter(item => item.visible);
          const item = visibledStacks[visibledStacks.length - 1];
          if (!item) return;
          // 暂时先不要弹出窗的关闭动画
          if (item.exitWay === "immediate") {
            popupDispatch({
              type: "popStack"
            });
          } else {
            popupDispatch({
              type: "changeStack",
              payload: {
                visible: false
              }
            });
          }
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [stacks]);
  const afterClose = item => {
    if (item.exitWay !== "hide") {
      popupDispatch({
        type: "popStack"
      });
    }
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: stacks.map(item => {
      const {
        visible,
        content,
        id,
        drawerAttributes,
        compProps = {}
      } = item;
      let drawerContent = null;
      if (content instanceof Function) {
        const Comp = content;
        drawerContent = /*#__PURE__*/_jsx(Comp, {
          ...compProps
        });
      } else {
        drawerContent = content;
      }
      return /*#__PURE__*/_jsx(_Drawer, {
        wrapClassName: "drawerContainer",
        ...drawerAttributes,
        width: "100%",
        visible: visible,
        footer: null,
        closeIcon: null,
        unmountOnExit: false,
        headerStyle: {
          display: "none"
        },
        afterClose: () => afterClose(item),
        children: drawerContent
      }, id);
    })
  });
});
export default PopupComp;